// src/components/AccountPage/VerifyOtp.jsx
"use client"

import { useLocation, useNavigate } from "react-router-dom"
import { useState } from "react"
import { useAuth } from "../../hooks/useAuth"
import { Notify } from "notiflix/build/notiflix-notify-aio"
import "./VerifyOtp.css"

const VerifyOtp = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { verifyOtp, checkIsUserLoggedIn } = useAuth()
    const [otp, setOtp] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    // Из состояния маршрута берём username, password и email
    const { email, username, password } = location.state || {}

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (otp.length !== 6) return

        setIsLoading(true)
        try {
            // Теперь передаём все необходимые поля
            await verifyOtp({ username, password, email, otp })

            // Обновляем состояние пользователя
            checkIsUserLoggedIn()

            // Переходим в профиль
            navigate("/profile", { replace: true })
            window.location.reload()

            Notify.success("Вы успешно зарегистрированы и вошли в аккаунт")
        } catch (error) {
            Notify.failure("Неверный код подтверждения")
        } finally {
            setIsLoading(false)
        }
    }

    const handleBack = () => {
        navigate(-1)
    }

    const handleOtpChange = (e) => {
        setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
    }

    return (
        <div className="otp-container">
            <div className="otp-wrapper">
                <button className="back-button" onClick={handleBack}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="m12 19-7-7 7-7" />
                        <path d="M19 12H5" />
                    </svg>
                    Назад
                </button>

                <div className="otp-card">
                    <div className="otp-header">
                        <h1 className="otp-title">Подтверждение кода</h1>
                        <p className="otp-description">
                            Мы отправили код подтверждения на вашу почту: <b>{email}</b>
                        </p>
                    </div>

                    <div className="otp-content">
                        <form onSubmit={handleSubmit} className="otp-form">
                            <div className="input-group">
                                <label htmlFor="otp" className="input-label">
                                    Код подтверждения
                                </label>
                                <input
                                    id="otp"
                                    type="text"
                                    placeholder="000000"
                                    value={otp}
                                    onChange={handleOtpChange}
                                    className="otp-input"
                                    maxLength={6}
                                    required
                                />
                                <p className="input-hint">Код действителен в течение 5 минут</p>
                            </div>

                            <button
                                type="submit"
                                className={`submit-button ${otp.length !== 6 || isLoading ? "disabled" : ""}`}
                                disabled={otp.length !== 6 || isLoading}
                            >
                                {isLoading ? (
                                    <span className="loading-content">
                    <div className="spinner"></div>
                    Проверка...
                  </span>
                                ) : (
                                    "Подтвердить"
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VerifyOtp
